import { useCallback, useMemo } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import type { PcmpRequestBatchesParams, PcmpUrgentBatchSearch } from '../types/pcmpRequest.types';
import { usePcmpQueueFilters } from './usePcmpQueueFilters';

const route = getRouteApi('/_auth/pcmp/requests/batches/$batchNo/');

/** An urgent batch's members: the queue filters and paging. */
export function usePcmpUrgentBatchFilters() {
  const { batchNo } = route.useParams();
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const setSearch = useCallback(
    (update: (prev: PcmpUrgentBatchSearch) => PcmpUrgentBatchSearch) => {
      void navigate({ search: update });
    },
    [navigate],
  );

  const queue = usePcmpQueueFilters(search, setSearch);
  const { appliedFilters, page, limit } = queue;

  const params = useMemo<PcmpRequestBatchesParams>(
    () => ({ ...appliedFilters, page, limit }),
    [appliedFilters, page, limit],
  );

  return { ...queue, batchNo, params };
}
